<template>
  <div class="field">
    <label class="label">Revisor de la ficha</label>
    <div class="select is-fullwidth">
      <select :value="value" :disabled="!loaded && !error" @change="$emit('input', $event.target.value ? Number($event.target.value) : null)">
        <option value="">Asignación automática / conservar revisor actual</option>
        <option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
      </select>
    </div>
    <p class="help">Se conserva al revisor actual si sigue autorizado y no participó en los cambios. En caso contrario, se asigna a quien tenga menos tareas asignadas o en curso; en un empate, a quien lleve más tiempo sin recibir una revisión. También puedes seleccionar un revisor manualmente.</p>
    <p v-if="error" class="help is-danger">{{ error }}</p>
    <p v-else-if="loaded && !users.length" class="help">No hay revisores elegibles. La tarea quedará pendiente de asignación.</p>
  </div>
</template>

<script>
export default {
  props: { value: Number, companyId: Number },
  data: () => ({ users: [], error: '', loaded: false }),
  watch: {
    companyId: { immediate: true, handler () { this.load() } }
  },
  methods: {
    async load () {
      this.error = ''
      this.loaded = false
      try {
        const response = await this.$axios.get('company/reviewers', { params: { company_id: this.companyId } })
        this.users = response.data.users
        if (this.value == null && response.data.current_reviewer_id) {
          this.$emit('input', response.data.current_reviewer_id)
        }
        this.loaded = true
      } catch (error) {
        this.error = 'No fue posible cargar los revisores.'
      }
    }
  }
}
</script>
